__turbopack_context__.v({
  "form": "profile-photo-dialog-module-scss-module__-7BskW__form",
  "form--wide": "profile-photo-dialog-module-scss-module__-7BskW__form--wide",
});
